import { ActionContext, Module } from "vuex";
import HistoryService from "@/services/history.service";
import type {
  PurchaseHistoryItem,
  SendUsageHistoryParams,
  UsageHistoryFetchParams,
  UsageHistoryItem,
} from "@/struct/HistoryStruct";
import { historyUsageMock } from "@/mocks/historyUsageMock";
import type { RootState } from "@/store";

export interface HistoryState {
  purchaseHistory: PurchaseHistoryItem[];
  isPurchaseHistoryLoading: boolean;
  usageHistory: UsageHistoryItem[];
  isUsageHistoryLoading: boolean;
}

const historyService = new HistoryService();

const historyModule: Module<HistoryState, RootState> = {
  namespaced: true,
  state: () => ({
    purchaseHistory: [],
    isPurchaseHistoryLoading: false,
    usageHistory: [],
    isUsageHistoryLoading: false,
  }),
  getters: {},
  mutations: {
    SET_PURCHASE_HISTORY(state, payload: PurchaseHistoryItem[]) {
      state.purchaseHistory = payload;
    },
    SET_PURCHASE_HISTORY_LOADING(state, payload: boolean) {
      state.isPurchaseHistoryLoading = payload;
    },
    SET_USAGE_HISTORY(state, payload: UsageHistoryItem[]) {
      state.usageHistory = payload;
    },
    SET_USAGE_HISTORY_LOADING(state, payload: boolean) {
      state.isUsageHistoryLoading = payload;
    },
  },
  actions: {
    fetchPurchaseHistory(
      { commit },
      payload: {
        limit: number;
        start: number;
        start_time: string;
        end_time: string;
      }
    ) {
      commit("SET_PURCHASE_HISTORY_LOADING", true);
      return historyService
        .getPurchaseHistory(
          payload.limit,
          payload.start,
          payload.start_time,
          payload.end_time
        )
        .then((res) => {
          commit("SET_PURCHASE_HISTORY", res.data.response ?? []);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          commit("SET_PURCHASE_HISTORY_LOADING", false);
        });
    },
    fetchUsageHistory({ commit }, params: UsageHistoryFetchParams) {
      commit("SET_USAGE_HISTORY_LOADING", true);
      const { limit, start_time, end_time } = params;
      return historyService
        .getUsageHistory(limit, start_time, end_time)
        .then((res) => {
          const usageHistory = res.data.response;
          commit("SET_USAGE_HISTORY", usageHistory ?? []);
        })
        .catch((err) => {
          console.log(err);
          commit("SET_USAGE_HISTORY", historyUsageMock);
        })
        .finally(() => {
          commit("SET_USAGE_HISTORY_LOADING", false);
        });
    },
    sendUsageHistory(
      _: ActionContext<HistoryState, RootState>,
      params: SendUsageHistoryParams
    ) {
      return historyService.sendUsageHistory(params);
    },
  },
};

export default historyModule;
